import React from 'react';
import './Speakers from.css';
import Adobe from "../../img/SF/Adobe.png";
import aws from "../../img/SF/aws.png";
import INVIDITechnologiesAB from "../../img/SF/INVIDITechnologiesAB.png";
import Databricks from "../../img/SF/Databricks.png";
import Comtura from "../../img/SF/Comtura.png";
import Google from "../../img/SF/Google.png";
import DellTechnologies from "../../img/SF/DellTechnologies.png";
import KPMG from "../../img/SF/KPMG.png";
import lakeFS from "../../img/SF/lakeFS.png";
import runai from "../../img/SF/runai.png";
import SAS from "../../img/SF/SAS.png";
import SPGlobal from "../../img/SF/SPGlobal.png";
import SphereEx from "../../img/SF/SphereEx.png";
import Thoughtworks from "../../img/SF/Thoughtworks.png";
import TigerGraph from "../../img/SF/TigerGraph.png";

const SpeakersFrom = (props) => {
    const state = {
        Speakers_item: [
            {
                img: Google,
            },
            {
                img: Adobe,
            },
            {
                img: aws,
            },
            {
                img: Thoughtworks,
            },
            {
                img: KPMG,
            },
            {
                img: Databricks,
            },
            {
                img: Comtura,
            },
            {
                img: DellTechnologies,
            },
            {
                img: lakeFS,
            },
            {
                img: SAS,
            },
            {
                img: runai,
            },
            {
                img: INVIDITechnologiesAB,
            },
            {
                img: SPGlobal,
            },
            {
                img: SphereEx,
            },
            {
                img: TigerGraph,
            },
        ],
    };

    const renderSpeakers_item = (item, i) => {
        return (
            <div className="logo_item speakers_from_item" key={`Numbers_item-${i}`}>
                <img src={item.img} alt="Speakers logo" />
            </div>
        );
    };

    return (
        <div className="speakers_from_wrap">
            <div className="container">
                <h2>Speakers from</h2>
                <div className="speakers_from">
                    {state.Speakers_item.map((item, i) => renderSpeakers_item(item, i))}
                </div>
            </div>
        </div>
    );
};

export default SpeakersFrom;